import React from 'react'
import Login from './components/login'
import Register from './components/register'
import logo from './logo.png'
import {login, register} from '../../actions'
import {Divider} from 'semantic-ui-react'

export default class AuthPage extends React.Component {
  render () {
    const {router} = this.props
    const isDev = router.location.query && router.location.query.dev
    const isReset = router.location.query && router.location.query.reset
    console.log(isReset)
    return (
      <div>
        <img style={{'display': 'block', 'maxWidth': '60%', 'margin': '2em auto'}} src={logo} alt='Factoripad' />
        <Login login={login} isReset={isReset} />
        {/*{isDev ? (<div><Divider horizontal>Or</Divider>*/}
          {/*<Register register={register} /></div>) : null}*/}
        <div style={{textAlign: 'center'}}>
          <a href='https://www.risqover.com'> Go to homepage </a>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/index.js